import React from 'react'
import Yup from './../../../../../helpers/custom-yup'
import moment from 'moment'
import Button from '../../../../../components/buttons/buttons.component'
import styled from 'styled-components'
import DatepickerInput from './../../../../../components/form-components/datepicker-input.component'
import StyledFlexContainer from './../../../../../components/containers/flex-container.component'
import { StyledTopic } from './styled-components'
import { breakpoints } from './../../../../../constants/breakpoints.constants'
import { Formik, Form } from 'formik'
import {
	TextInput,
	SelectInput,
	CheckboxToggleInput
} from '../../../../../components/form-components/inputs.component'

const StyledButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	padding-top: 2.7rem;
	margin-bottom: 25px;

	.solicitation-button {
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			margin-right: 7px;
		}
	}
`

const StyledAcceptTerms = styled.div`
	align-items: center;
	display: flex;
	margin-top: 54px;
	& > p {
		margin-left: 15px;
	}
`

const UserTicketForm = ({ className, onSubmit, style }) => (
	<div style={style} className={className}>
		<StyledTopic className="blue">Nova solicitação</StyledTopic>
		<p>
			<span className="bold">Atenção:</span> <br />
			{pontosPlanalto} <br />
			{textExplanation} <br />
			{appPlanalto}
		</p>
		<Formik
			onSubmit={onSubmit}
			validationSchema={schema}
			initialValues={initialValues}
			render={props => renderFormik(props)}
		/>
	</div>
)

const schema = Yup.object().shape({
	acceptTerms: Yup.bool(),
	busSeat: Yup.string().required('Informe a poltrona'),
	partner: Yup.string().required('Informe o parceiro'),
	ticketNumber: Yup.string().required('Informe o bilhete'),
	tripDate: Yup.date().required('Informe a data da viagem'),
	ticketSequence: Yup.string().required('Informe a série do bilhete')
})

const partnerOptions = [{ label: 'Planalto', value: 'planalto' }]

const initialValues = {
	busSeat: '',
	tripDate: '',
	ticketNumber: '',
	acceptTerms: false,
	ticketSequence: '',
	partner: partnerOptions[0].value
}

const dateStart = moment().format('DD/MM/YYYY')

const pontosPlanalto = `• Apenas pontuarão via solicitação de pontos passagens da Planalto.`
const textExplanation = `• Passagens de outras empresas compradas no guichê ou site da empresa não pontuarão via solicitação de pontos.`
const appPlanalto = `• Passagens compradas pelo site ou app da Planalto pontuam automaticamente sem a necessidade de solicitação de pontos.`

function renderFormik(props) {
	return (
		<Form className="form" noValidate>
			<StyledFlexContainer>
				<SelectInput
					{...props}
					id="partner"
					multi={false}
					disabled={true}
					label="Parceiro *"
					className="col-12"
					options={partnerOptions}
					placeholder="Selecione ..."
				/>
			</StyledFlexContainer>
			<StyledFlexContainer>
				<TextInput
					{...props}
					maxLength={6}
					label="Série *"
					onlyAlphanumeric
					className="col-12"
					id="ticketSequence"
				/>
			</StyledFlexContainer>
			<StyledFlexContainer>
				<TextInput
					noSpaces
					{...props}
					maxLength={10}
					id="ticketNumber"
					label="Bilhete *"
					className="col-12"
				/>
			</StyledFlexContainer>
			<StyledFlexContainer>
				<TextInput
					{...props}
					id="busSeat"
					maxLength={3}
					label="Poltrona *"
					className="col-12"
				/>
			</StyledFlexContainer>
			<StyledFlexContainer>
				<DatepickerInput
					{...props}
					id="tripDate"
					maxLength={10}
					date={dateStart}
					className="col-12"
					openDirection="up"
					label="Data da viagem *"
				/>
			</StyledFlexContainer>
			<StyledFlexContainer>
				<StyledAcceptTerms>
					<CheckboxToggleInput id="acceptTerms" {...props} />
					<p>
						Afirmo que sou o passageiro do bilhete informado e estou
						ciente que devo guardar o mesmo em boas condições para
						comprovação caso me seja requisitado. *
					</p>
				</StyledAcceptTerms>
			</StyledFlexContainer>
			<StyledButtonContainer>
				<Button className="solicitation-button" primary type="submit">
					Solicitar
				</Button>
			</StyledButtonContainer>
		</Form>
	)
}

export default UserTicketForm
